import { adminApi } from "../utils/admin-api-axios";

export const getListingsByUser = async (id) => {
  try {
    const response = await adminApi.getListingsByUser(id);
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching listings:", error);
    return { success: false, error: error.message };
  }
};
